import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StoreTypes } from 'mbs-ui-shared@store/storeTypes.enum';
import { LicensesState } from './state';

const selectLicensesState = createFeatureSelector<LicensesState>(StoreTypes.Licenses);

export const selectState = createSelector(selectLicensesState, (store) => store);

export const selectLicenseTypes = createSelector(selectState, (store) => store.licenseTypes);
export const selectLicenseTypesMap = createSelector(selectState, (store) => store.licenseTypesMap);

export const selectPermissionFlags = createSelector(selectState, (store) => store.permissionFlags);
export const selectPermissionFlagsLoaded = createSelector(selectState, (store) => store.permissionFlagsLoaded);


export const selectBalance = createSelector(selectState, (store) => store.balance);

export const selectLoading = createSelector(selectState, (store) => store.actionsInLoading > 0);

export const selectAssignedLicense = createSelector(selectState, (store) => store.assignedLicense);
